import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { NamedLink } from "../../components";
import css from "./Sidebar.module.css";
import { GrSecure } from "react-icons/gr";

const steps = [
  {
    id: 1,
    title: "Company Information",
    description: "Enter your company details",
  },
  {
    id: 2,
    title: "Contact Person",
    description: "Add primary contact details",
  },
  {
    id: 3,
    title: "Industry Details",
    description: "Select industry information",
  },
  {
    id: 4,
    title: "Agreements",
    description: "Accept required agreements",
  },
  {
    id: 5,
    title: "Review & Submit",
    description: "Review before submitting",
  },
];

const Sidebar = props => {
  const {
    className,
    rootClassName,
    currentStep,
  } = props;

  const classes = classNames(
    rootClassName || css.root,
    className
  );

  return (
    <div className={classes}>
      <div className={css.main}>

        <div className={css.steps}>

          {steps.map((step, index) => {

            const active = currentStep === step.id;
            const completed = currentStep > step.id;

            return (
              <div
                key={step.id}
                className={css.step}
              >

               <div>

                  <div
                    className={classNames(css.circle, {
                      [css.activeCircle]: active,
                      [css.completedCircle]: completed,
                    })}
                  >
                    {completed ? "✓" : step.id}
                  </div>

                  {index !== steps.length - 1 && (
                    <div
                      className={classNames(css.line, {
                        [css.activeLine]: completed,
                      })}
                    />
                  )}

                </div>

                <div
                  className={classNames(css.card, {
                    [css.activeCard]: active,
                  })}
                >
                  <h4>{step.title}</h4>

                  <p>{step.description}</p>
                </div>

              </div>
            );
          })}

        </div>

        

       

        <p className={css.loginLink}>
          Already have an account? <NamedLink name="LoginPage">Log in</NamedLink>
        </p>

      </div>
    </div>
  );
};

Sidebar.defaultProps = {
  className: null,
  rootClassName: null,
  currentStep: 1,
};

Sidebar.propTypes = {
  className: PropTypes.string,
  rootClassName: PropTypes.string,
  currentStep: PropTypes.number,
};

export default Sidebar;